import { IEnvironmentEntity } from '../environment';
export const procedo: IEnvironmentEntity = {
	development: {
		url: process.env.REACT_APP_FRONTEND_PROCEDO_URL_STAGING,
	},
	staging: {
		url: process.env.REACT_APP_FRONTEND_PROCEDO_URL_STAGING,
	},
	production: {
		url: process.env.REACT_APP_FRONTEND_PROCEDO_URL_PRODUCTION,
	},
};
